export const defaultFormData = {
  companyName: "",
  statusId: "Active",
  addressCareOf: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
};

export const managementStatusLabels = {
  Active: "Active",
  Cancelled: "Cancelled",
  Collection: "Collection",
  Pending: "Pending",
  Transferred: "Transferred",
  Expired: "Expired",
};

export const ManagementInfo = [
  {
    key: "companyName",
    label: "Name",
    tooltip: `Specifies the management company's name and corporation status. For example Inc. or Ltd.`,
    required: true,
  },
  {
    key: "statusId",
    label: "Status",
    tooltip: "Specifies the current account status of the management company.",
    type: "select",
    options: managementStatusLabels,
    required: true,
  },
];

export const AddressInfo = [
  {
    key: "addressCareOf",
    label: "Address Care Of",
    tooltip: "Specifies the management company's recipient of mail.",
  },
  {
    key: "address",
    label: "Address",
    tooltip: "Specifies the management company's street address.",
    required: true,
  },
  {
    key: "address2",
    label: "Address 2",
    tooltip: "Specifies the management company's additional address info.",
  },
  {
    key: "city",
    label: "City",
    tooltip: "Specifies the management company's city.",
    required: true,
  },
  {
    key: "state",
    label: "State",
    type: "select",
    tooltip: "Specifies the management company's state.",
    required: true,
  },
  {
    key: "zip",
    label: "Zip",
    tooltip: "Specifies the management company's zip code.",
    required: true,
  },
];

export const managementCompanyFields = [
  {
    key: "companyName",
    label: "Name",
    tooltip:
      "Specifies the management company's name and corporation status. For example Inc. or Ltd.",
  },
  {
    key: "statusId",
    label: "Status",
    tooltip: "Specifies the current account status of the management company.",
  },
  {
    key: "addressCareOf",
    label: "Address Care Of",
    tooltip: "Specifies the management company's recipient of mail.",
  },
  {
    key: "address",
    label: "Address",
    tooltip: "Specifies the management company's street address.",
  },
  {
    key: "address2",
    label: "Address 2",
    tooltip: "Specifies the management company's additional address info.",
  },
  {
    key: "city",
    label: "City",
    tooltip: "Specifies the management company's city.",
  },
  {
    key: "state",
    label: "State",
    tooltip: "Specifies the management company's state.",
  },
  {
    key: "zip",
    label: "Zip",
    tooltip: "Specifies the management company's zip code.",
  },
];

export const customerStatusLabels = {
  Active: "Active",
  Cancelled: "Cancelled",
  Collection: "Collection",
  Pending: "Pending",
  Transferred: "Transferred",
  Expired: "Expired",
};
